// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"c42c84d8","295":"0f34089e"}[chunkId] + ".chunk.js";
};